export interface ModuleField {
  field: string
  fieldName: string
  filterEmpty?: boolean
  valueType?: 'string' | 'number' | 'boolean'
}

export interface IntegrationModule {
  id: string
  name: string
  endpoint: string
  createEndpoint?: string
  fields: ModuleField[]
  tenantType?: 'fashion' | 'aco'
  responseKey?: string
  paginationType?: 'offset' | 'page' | 'skip-take'
}

export type WriteRegistrationType = 'collection' | 'family' | 'product' | 'fabric' | 'trim'

export interface WriteIntegrationModule {
  id: string
  name: string
  endpoint: string
  createEndpoint: string
  tenantType: 'fashion' | 'aco'
  fieldKey: string
  fieldName: string
  responseKey?: string
  paginationType?: 'offset' | 'page' | 'skip-take'
  writeRegistrationType: WriteRegistrationType
}

export const integrationModules: IntegrationModule[] = [
  {
    id: 'companies',
    name: 'Empresas',
    endpoint: '/companies/companies',
    createEndpoint: '/companies/companies',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'companyName', fieldName: 'Razão Social' },
      { field: 'cnpj', fieldName: 'CNPJ' },
      { field: 'cpf', fieldName: 'CPF' },
      { field: 'stateRegistration', fieldName: 'Inscrição Estadual' },
      { field: 'phone', fieldName: 'Telefone' },
      { field: 'email', fieldName: 'E-mail' },
      { field: 'companyTypes', fieldName: 'Tipo de Empresa', filterEmpty: true },
      { field: 'cep', fieldName: 'CEP' },
      { field: 'street', fieldName: 'Rua' },
      { field: 'number', fieldName: 'Número' },
      { field: 'complement', fieldName: 'Complemento' },
      { field: 'neighborhood.name', fieldName: 'Bairro' },
      { field: 'city.name', fieldName: 'Cidade' },
      { field: 'state.name', fieldName: 'Estado' },
    ]
  },
  {
    id: 'equipment',
    name: 'Equipamentos',
    endpoint: '/equipment/equipment',
    createEndpoint: '/equipment/equipment',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'code', fieldName: 'Código' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'model', fieldName: 'Modelo' },
      { field: 'manufacturer', fieldName: 'Fabricante' },
      { field: 'year', fieldName: 'Ano' },
      { field: 'dimension', fieldName: 'Dimensão' },
      { field: 'weight', fieldName: 'Peso' },
      { field: 'costPerHour', fieldName: 'Custo por Hora' },
      { field: 'capacity', fieldName: 'Capacidade' },
    ]
  },
  {
    id: 'vehicles',
    name: 'Veículos',
    endpoint: '/equipment/vehicles',
    createEndpoint: '/equipment/vehicles',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'plate', fieldName: 'Placa' },
      { field: 'model', fieldName: 'Modelo' },
      { field: 'year', fieldName: 'Ano' },
      { field: 'capacity', fieldName: 'Capacidade' },
      { field: 'restriction', fieldName: 'Restrição' },
      { field: 'bodyType', fieldName: 'Tipo de Carroceria' },
    ]
  },
  {
    id: 'resources',
    name: 'Insumos',
    responseKey: 'data',
    paginationType: 'skip-take',
    endpoint: '/resources/resource',
    createEndpoint: '/resources/resource',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'code', fieldName: 'Código' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'category.name', fieldName: 'Categoria' },
      { field: 'type.name', fieldName: 'Tipo' },
      { field: 'material', fieldName: 'Material' },
      { field: 'format', fieldName: 'Formato' },
      { field: 'fabrication', fieldName: 'Fabricação' },
      { field: 'ncm', fieldName: 'NCM' },
      { field: 'shelf', fieldName: 'Prateleira' },
      { field: 'stockLocation', fieldName: 'Localização de Estoque' },
      { field: 'stockUnit', fieldName: 'Unidade de Estoque' },
      { field: 'unitQuantity', fieldName: 'Qtd. por Unidade' },
      { field: 'totalWeight', fieldName: 'Peso Total' },
      { field: 'lengthInMm', fieldName: 'Comprimento (mm)' },
      { field: 'dimension1', fieldName: 'Dimensão 1' },
      { field: 'dimension2', fieldName: 'Dimensão 2' },
      { field: 'suppliers', fieldName: 'Fornecedores', filterEmpty: true },
      { field: 'colors', fieldName: 'Cores', filterEmpty: true },
    ]
  },
  {
    id: 'services',
    name: 'Serviços',
    endpoint: '/services/service-stage',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'Category_Stage.name', fieldName: 'Categoria' },
      { field: 'Type_Category_Stage.name', fieldName: 'Tipo' },
      { field: 'machines', fieldName: 'Máquinas', filterEmpty: true },
      { field: 'suppliers', fieldName: 'Fornecedores', filterEmpty: true },
    ]
  },
  {
    id: 'production',
    name: 'Produção',
    tenantType: 'aco',
    paginationType: 'skip-take',
    endpoint: '/production-flow/service',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'codeOfOP', fieldName: 'Código da OP' },
      { field: 'status', fieldName: 'Status' },
    ]
  },
  {
    id: 'fashion-stock',
    name: 'Estoque',
    tenantType: 'fashion',
    endpoint: '/backend-fashion-orders/fashion-product/stocks',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'material', fieldName: 'Material' },
      { field: 'format', fieldName: 'Formato' },
      { field: 'originCountry', fieldName: 'País de origem' },
      { field: 'finishing', fieldName: 'Acabamento' },
      { field: 'supplier', fieldName: 'Fornecedor' },
      { field: 'color', fieldName: 'Cor', filterEmpty: true },
      { field: 'stockStreet', fieldName: 'Rua' },
      { field: 'shelf', fieldName: 'Prateleira' },
      { field: 'stockLocation', fieldName: 'Localização' },
      { field: 'fabrication', fieldName: 'Fabricação' },
      { field: 'heatNumber', fieldName: 'Número da Corrida' },
      { field: 'measurementUnit', fieldName: 'Unidade' },
      { field: 'quantity', fieldName: 'Quantidade' },
      { field: 'availableBalance', fieldName: 'Saldo Disponível' },
      { field: 'totalWeight', fieldName: 'Peso Total' },
      { field: 'lengthInMm', fieldName: 'Comprimento (mm)' },
      { field: 'dimension1', fieldName: 'Dimensão 1' },
      { field: 'dimension2', fieldName: 'Dimensão 2' },
      { field: 'costPerMm', fieldName: 'Custo/mm' },
      { field: 'costPerKg', fieldName: 'Custo/Kg' },
      { field: 'totalCmc', fieldName: 'CMC Total' },
      { field: 'totalCost', fieldName: 'Custo Total' },
      { field: 'ncm', fieldName: 'NCM' },
      { field: 'trackingNumber', fieldName: 'Rastreamento' },
      { field: 'family', fieldName: 'Família' },
      { field: 'characteristic', fieldName: 'Característica' },
      { field: 'status', fieldName: 'Status' },
      { field: 'isActivated', fieldName: 'Ativo', valueType: 'boolean' },
      { field: 'nf', fieldName: 'NF' },
      { field: 'purchaseOrder', fieldName: 'Pedido de Compra' },
      { field: 'receivedDate', fieldName: 'Data de Recebimento' },
    ]
  },
  {
    id: 'steel-stock',
    name: 'Estoque',
    tenantType: 'aco',
    paginationType: 'skip-take',
    endpoint: '/backend/stock/integration',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'material', fieldName: 'Material' },
      { field: 'format', fieldName: 'Formato' },
      { field: 'finishing', fieldName: 'Acabamento' },
      { field: 'heatTreatment', fieldName: 'Tratamento Térmico' },
      { field: 'measurementUnit', fieldName: 'Unidade' },
      { field: 'quantity', fieldName: 'Quantidade' },
      { field: 'availableBalance', fieldName: 'Saldo Disponível' },
      { field: 'totalWeight', fieldName: 'Peso Total' },
      { field: 'dimension1', fieldName: 'Dimensão 1' },
      { field: 'dimension2', fieldName: 'Dimensão 2' },
      { field: 'costPerKg', fieldName: 'Custo/Kg' },
      { field: 'costPerMm', fieldName: 'Custo/mm' },
      { field: 'totalCost', fieldName: 'Custo Total' },
      { field: 'lengthInMm', fieldName: 'Comprimento (mm)' },
      { field: 'totalCmc', fieldName: 'CMC Total' },
      { field: 'runNumber', fieldName: 'Nº de Corrida' },
      { field: 'family', fieldName: 'Família' },
      { field: 'characteristic', fieldName: 'Característica' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'status', fieldName: 'Status' },
      { field: 'isActivated', fieldName: 'Ativo', valueType: 'boolean' },
      { field: 'nf', fieldName: 'NF' },
      { field: 'certificateNumber', fieldName: 'Nº Certificado' },
      { field: 'purchaseOrder', fieldName: 'Pedido de Compra' },
      { field: 'receivedDate', fieldName: 'Data de Recebimento' },
      { field: 'trackingNumber', fieldName: 'Rastreamento' },
    ]
  },
  {
    id: 'fashion-collections',
    name: 'Coleções',
    tenantType: 'fashion',
    responseKey: 'content',
    endpoint: '/backend-fashion-orders/fashion-product/collections',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'Family', fieldName: 'Famílias', filterEmpty: true },
      { field: 'GroupInCollection', fieldName: 'Grupos', filterEmpty: true },
      { field: 'GradeInCollection', fieldName: 'Grades', filterEmpty: true },
      { field: 'CollectionColor', fieldName: 'Cores', filterEmpty: true },
      { field: 'CollectionMaterial', fieldName: 'Materiais', filterEmpty: true },
    ]
  },
  {
    id: 'fashion-families',
    name: 'Famílias',
    tenantType: 'fashion',
    responseKey: 'content',
    endpoint: '/backend-fashion-orders/fashion-product/families',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'Collection.name', fieldName: 'Coleção' },
      { field: 'GroupInFamily', fieldName: 'Grupos', filterEmpty: true },
      { field: 'GradeInFamily', fieldName: 'Grades', filterEmpty: true },
      { field: 'FamilyColor', fieldName: 'Cores', filterEmpty: true },
    ]
  },
  {
    id: 'fashion-products',
    name: 'Composição do Produto',
    tenantType: 'fashion',
    endpoint: '/backend-fashion-orders/fashion-product',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'productCode', fieldName: 'Código' },
      { field: 'referenceProduct', fieldName: 'Produto Referência' },
      { field: 'norm', fieldName: 'Norma' },
      { field: 'price', fieldName: 'Preço' },
      { field: 'status', fieldName: 'Status' },
      { field: 'Group.name', fieldName: 'Grupo' },
      { field: 'Family.name', fieldName: 'Família' },
      { field: 'Collection.name', fieldName: 'Coleção' },
      { field: 'GradeInProduct', fieldName: 'Grades', filterEmpty: true },
      { field: 'ProductItemColor', fieldName: 'Cores', filterEmpty: true },
    ]
  },
  {
    id: 'fashion-orders',
    name: 'Produção',
    tenantType: 'fashion',
    paginationType: 'skip-take',
    endpoint: '/production-flow/service',
    fields: [
      { field: 'id', fieldName: 'OP' },
      { field: 'set', fieldName: 'Conjunto' },
      { field: 'orderId', fieldName: 'Pedido' },
      { field: 'status', fieldName: 'Etapa (Status)' },
      { field: 'priority', fieldName: 'Prioridade' },
      { field: 'productionDay', fieldName: 'Dia' },
      { field: 'Product.name', fieldName: 'Produto' },
      { field: 'Product.Collection.name', fieldName: 'Coleção' },
      { field: 'Product.Family.name', fieldName: 'Família' },
      { field: 'color.name', fieldName: 'Cor' },
      { field: 'Machine.code', fieldName: 'Código da Máquina' },
      { field: 'Machine.name', fieldName: 'Máquina' },
      { field: 'User_Services_cutterIdToUser.name', fieldName: 'Cortador' },
      { field: 'User_Services_cutterIdToUser.email', fieldName: 'E-mail do Cortador' },
      { field: 'User_Services_dressmakerIdToUser.name', fieldName: 'Costureira' },
      { field: 'User_Services_dressmakerIdToUser.email', fieldName: 'E-mail da Costureira' },
      { field: 'FashionProductionItems', fieldName: 'Itens da OP', filterEmpty: true },
      { field: 'FashionProductionItems.fashionOrderId', fieldName: 'Pedidos da OP' },
      { field: 'FashionProductionItems.quantityForThisProduction', fieldName: 'Qtd. por Pedido' },
      { field: 'FashionProductionItems.fashionOrder.Company_Order_clientIdToCompany.companyName', fieldName: 'Cliente(s)' },
      { field: 'FashionProductionItems.fashionOrder.finalDateOfDelivery', fieldName: 'Entrega(s)' },
      { field: 'createdAt', fieldName: 'Criado em' },
      { field: 'updatedAt', fieldName: 'Atualizado em' },
    ]
  },
]

export const integrationTypes = [
  { id: 'read', name: 'Leitura', description: 'Apenas consulta os dados existentes' },
  { id: 'write', name: 'Registro', description: 'Consulta e permite criar novos registros' },
]

export const writeIntegrationModules: WriteIntegrationModule[] = [
  {
    id: 'fashion-collections-write',
    name: 'Coleções',
    endpoint: '/backend-fashion-orders/fashion-product/collections',
    createEndpoint: '/backend-fashion-orders/fashion-product/collections',
    tenantType: 'fashion',
    fieldKey: 'name',
    fieldName: 'Nome',
    responseKey: 'content',
    writeRegistrationType: 'collection',
  },
  {
    id: 'fashion-families-write',
    name: 'Famílias',
    endpoint: '/backend-fashion-orders/fashion-product/families',
    createEndpoint: '/backend-fashion-orders/fashion-product/families',
    tenantType: 'fashion',
    fieldKey: 'name',
    fieldName: 'Nome',
    responseKey: 'content',
    writeRegistrationType: 'family',
  },
  {
    id: 'fashion-products-write',
    name: 'Produto',
    endpoint: '/backend-fashion-orders/fashion-product',
    createEndpoint: '/backend-fashion-orders/fashion-product',
    tenantType: 'fashion',
    fieldKey: 'name',
    fieldName: 'Nome',
    writeRegistrationType: 'product',
  },
  {
    id: 'fashion-fabrics-write',
    name: 'Tecidos',
    endpoint: '/backend/stock/integration',
    createEndpoint: '/backend/stock-fashion',
    tenantType: 'fashion',
    fieldKey: 'description',
    fieldName: 'Descrição',
    responseKey: 'items',
    paginationType: 'skip-take',
    writeRegistrationType: 'fabric',
  },
  {
    id: 'fashion-trims-write',
    name: 'Aviamentos',
    endpoint: '/resources/resource',
    createEndpoint: '/resources/resource',
    tenantType: 'fashion',
    fieldKey: 'name',
    fieldName: 'Nome',
    responseKey: 'data',
    paginationType: 'skip-take',
    writeRegistrationType: 'trim',
  },
]

export const getModuleById = (id: string): IntegrationModule | undefined => {
  return integrationModules.find(module => module.id === id)
}

export const getFieldsByModuleId = (moduleId: string): ModuleField[] => {
  const module = getModuleById(moduleId)
  return (module?.fields || []).filter(f => f.field !== 'id')
}
